/**
 * @generated SignedSource<<cd93c162f746395a01cae6298d3710ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStoryTellingMainMedia_refactor_storyTellingTab$data = {
  readonly mainImage: string | null;
  readonly mainVideo: string | null;
  readonly tabTitle: string;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab">;
  readonly " $fragmentType": "PdpSharedStoryTellingMainMedia_refactor_storyTellingTab";
};
export type PdpSharedStoryTellingMainMedia_refactor_storyTellingTab$key = {
  readonly " $data"?: PdpSharedStoryTellingMainMedia_refactor_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStoryTellingMainMedia_refactor_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedStoryTellingMainMedia_refactor_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainVideo",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab"
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "cfbd1d3f5f462a4ab16dfdab79fdd1e6";

export default node;
